// the path where business concepts are stored in the document, generated during collation
export const BUSINESS_CONCEPTS_PATH = '_businessConcepts';
